module.exports = __webpack_public_path__ + "static/media/37.4c8519f3.png";